export default {
  title: "وظائف و صلاحيات",
  subtitle: "إدارة وظائف و صلاحيات المستخدمين",
  
  addNew: "إضافة وظيفة جديدة",
  createRole: "إنشاء وظيفة",
  editRole: "تعديل وظيفة",
  deleteRole: "حذف وظيفة",
  
  fields: {
    name: "اسم الوظيفة",
    description: "الوصف",
    permissions: "الصلاحيات",
    isActive: "نشط",
    level: "مستوى الوصول",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث",
    permissionIds: "معرفات الصلاحيات"
  },
  
  placeholders: {
    name: "أدخل اسم الوظيفة",
    description: "أدخل وصف الوظيفة",
    level: "اختر مستوى الوصول"
  },
  
  messages: {
    createSuccess: "تم إنشاء الوظيفة بنجاح",
    createError: "فشل في إنشاء الوظيفة",
    updateSuccess: "تم تحديث الوظيفة بنجاح",
    updateError: "فشل في تحديث الوظيفة",
    deleteSuccess: "تم حذف الوظيفة بنجاح",
    deleteError: "فشل في حذف الوظيفة",
    deleteConfirm: "هل أنت متأكد من حذف هذا الوظيفة؟",
    noRoles: "لا توجد وظائف",
    loadingRoles: "جاري تحميل الوظائف...",
    loadingPermissions: "جاري تحميل الصلاحيات...",
    fetchError: "فشل في جلب الوظائف"
  },
  
  validation: {
    nameRequired: "اسم الوظيفة مطلوب",
    nameMinLength: "اسم الوظيفة يجب أن يكون على الأقل حرفين",
    nameMaxLength: "اسم الوظيفة يجب ألا يتجاوز 50 حرف",
    descriptionMaxLength: "الوصف يجب ألا يتجاوز 200 حرف",
    permissionsRequired: "صلاحية واحدة على الأقل مطلوبة",
    fillAllFields: "يرجى ملء جميع الحقول المطلوبة"
  },
  
  table: {
    name: "الاسم",
    description: "الوصف",
    permissions: "الصلاحيات",
    level: "المستوى",
    status: "الحالة",
    actions: "خيارات الأوامر"
  },
  
  levels: {
    admin: "مدير",
    manager: "مدير قسم",
    user: "مستخدم",
    guest: "ضيف"
  },
  
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط"
  },
  
  breadcrumbs: {
    roles: "الوظائف",
    create: "إنشاء وظيفة",
    edit: "تعديل الوظيفة",
    view: "عرض الوظيفة"
  },

  buttons: {
    submit: "إرسال",
    update: "تحديث",
    submitting: "جاري الإرسال...",
    updating: "جاري التحديث...",
    backToIndex: "العودة للقائمة"
  }
};
